export default "__VITE_ASSET__5_XYr338__"